
import {  useState,useContext } from "react";
import PerformanceEvaluationContext from "../../../context/PerformanceEvaluationContext/PerformanceEvaluationContext";
import { openCollaboratoPerformanceEvaluationModal,createPerformanceEvaluationModal } from "../../../context/PerformanceEvaluationContext/Actions";
import { eliminaPerformanceEvaluationModal } from "../../../context/PerformanceEvaluationContext/Actions";
import { IconButton, Menu, MenuItem } from "@material-ui/core";
import {useMutation } from "@apollo/client";
import {UPDATE_STEP_PERFORMANCE_EVALUATION,
        GET_ALL_PERFORMANCES_EVALUATION,
        UPDATE_FINALIZE_PERFORMNACE_EVALUATION } 
from "../../../Querys/performanceEvaluation/querys";
import Box from '@mui/material/Box';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { ErrorAlert } from '../../../alerts/errorAlert';
import { SuccessfulAlert } from "../../../alerts/successAlerts";
import { LoadingAlert } from "../../../alerts/loadingAlerts";

const MenuCrud = (props:any) => {
    const {dispatch} = useContext(PerformanceEvaluationContext);  
    const [anchorEl, setAnchorEl] = useState<any>(null);
    const [updateStepPerformanceEv] = useMutation(UPDATE_STEP_PERFORMANCE_EVALUATION, {
        refetchQueries: [{ query: GET_ALL_PERFORMANCES_EVALUATION }]
      });
    const [finalizePermormanceEv] = useMutation(UPDATE_FINALIZE_PERFORMNACE_EVALUATION, {
      refetchQueries: [{query: GET_ALL_PERFORMANCES_EVALUATION }]
    })
    const open = Boolean(anchorEl);   
    const openMenu = (e: any): void => {
      setAnchorEl(e.currentTarget);
    };  

    const deleteModal = async (id: any,active:any) => {
        setAnchorEl(null);        
        if(active==="Activo")
        {
            return ErrorAlert({ text: 'No es posible eliminar una Evaluación que este activa' });
        }
        
        eliminaPerformanceEvaluationModal(id,true, dispatch)       
    }

    const changeStatus = async (id: any) => {
        setAnchorEl(null);        
        LoadingAlert({ title: "Enviando..." }); 
        await updateStepPerformanceEv({
            variables: {
              id: id
            }
          });
        SuccessfulAlert({ text: 'Se ha cambiado de estatus'})
    }
    
    const duplicated = async (id: any) => {
        setAnchorEl(null);                
        createPerformanceEvaluationModal(id,props.item,true, dispatch)
       }

   const verCol = async (id: any) => {
        setAnchorEl(null);        
        openCollaboratoPerformanceEvaluationModal(id.toString(),true,true, dispatch)
    }

    const  finalizePerformance = async (id: any) => {
      setAnchorEl(null);        
      try{
        await finalizePermormanceEv({
          variables: {
            updateFinalizePerformanceEvaluationId: id
          }
        })
        SuccessfulAlert({
          text: "Evaluación de desempeño finalizada correctamente.",
        });
      }catch(error){
        ErrorAlert({
          text: "Ocurrió un error al intentar finalizar esta Evaluación de desempeño.",
        });
      }
    }

  return (
     <>
          <Box mr={2} 
             className="menuListNewPrestacion">
                <IconButton onClick={openMenu}
                   className="menuListOptionNewPrestacion"
                 >
                  <MoreVertIcon  className="moreOptionNewPrestacion"  />  
                  </IconButton>
                </Box>         
            <Menu
                className="MoreVerIcon"
                anchorEl={anchorEl}
                open={open}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                onClose={() => setAnchorEl(null)}>
                 {props.item.step==="definicion" &&(
                <MenuItem 
                  disabled={props.disabledMenu}
                  onClick={() => duplicated(props.id)}
                     >
                    <div   className="contenedorTextoMenuPrestacion" >
                        <span className="textoMenuEditarPrestacion" >Duplicar</span>
                    </div>
                    <div style={{ marginLeft: "24px" }}>
                       <ContentCopyIcon className="iconoMenuViewPrestacion" />
                    </div>
                </MenuItem>  
                 )}
                {/* {CheckPermission("Calendario.AgregarDiaInhabil") && (*/
                <MenuItem  
                 disabled={props.disabledMenu}
                  onClick={() => verCol(props.id)}
                >
                    <div   className="contenedorTextoMenuPrestacion" >
                    <span className="textoMenuEditarPrestacion" >Ver</span>
                    </div>
                    <div style={{ marginLeft: "55px" }}>
                    <VisibilityIcon className="iconoMenuViewPrestacion"/>
                    </div>
                </MenuItem>                            
                /*)} */}             
                {props.item.step==="retroalimentacion" ?
                <MenuItem 
                 
                  onClick={() => finalizePerformance(props.id)}
                >
                  <div  className="contenedorTextoMenuPrestacion" >
                      <span className="textoMenuEditarPres" >Finalizar</span>
                  </div>
                  <div  className="imgEditaPres" >
                        {/* <img className="iconoMenuPres"   src="/assets/svg/icono-editar.svg" alt="Editar" /> */}
                   </div>
                </MenuItem>
                :null
                }
              {props.item.step==="evaluacion" ?
                <MenuItem 
                   disabled={props.disabledMenu}
                   onClick={() => changeStatus(props.id )}
                 >
                    <div   className="contenedorTextoMenuPrestacion" >
                        <span className="textoMenuEditarPrestacion" >Retroalimentación</span>
                    </div>
                    {/* <div style={{ marginLeft: "55px" }}>
                        <UpdateIcon className="iconoMenuViewPrestacion" />
                    </div> */}
                </MenuItem>:null    
                }

                {/* )}
                {CheckPermission("Prestaciones.Eliminar") && ( */
                <MenuItem 
                onClick={() => deleteModal(props.id,props.active)}
                 >
                <div className="contenedorTextoMenuPrestacion" >
                    <span className="textoMenuEliminarPrestacion">Eliminar</span>
                </div>
                <div className="imgDeletePres">
                    <img 
                     className="iconoMenuEliminarPrestacion"
                     src="/assets/svg/icono-eliminar.svg" alt="Eliminar" />
                </div>
                </MenuItem>             
               /*  )} */}
           
            </Menu>   
           
        </>
  )
}

export default MenuCrud
